module.exports = __webpack_public_path__ + "910d4bd079b869f493912f6959dc0d77.svg";